import API from '../..';
import StaffAPI from '../../staffAPI';
const ENTITY = 'products';

export const filterItems = ({
    orderBy = 'created_at',
    page = 1,
    perPage = 25,
    searchText = '',
    sortBy = null,
} = {}) =>
    API.get(`/api/v1/${ENTITY}/`, {
        params: {
            order_by: orderBy,
            page: page,
            per_page: perPage,
            search: searchText,
            sort: sortBy,
        },
    });

export const getBrands = () =>
    StaffAPI.get(`/api/v1/${ENTITY}/panels/brands/`, {});

export const filterPanels = ({
    brand,
    max_power,
    orderBy = 'created_at',
    page = 1,
    perPage = 25,
    searchText = '',
    sortBy = null,
} = {}) =>
    StaffAPI.get(`/api/v1/${ENTITY}/panels/`, {
        params: {
            brand,
            max_power,
            order_by: orderBy,
            page: page,
            per_page: perPage,
            search: searchText,
            sort: sortBy,
        },
    });

export const getPanelsIds = () =>
    API.get(`/api/v1/panels-ids/`, {
        params: {
            status_flag: 'active',
        },
    });
